import React, { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Top40Chart = () => {
  const [items, setItems] = useState([]);
  const [year, setYear] = useState(null);
  const [date, setDate] = useState("");

  const NL_MONTHS = [
    "januari", "februari", "maart", "april", "mei", "juni",
    "juli", "augustus", "september", "oktober", "november", "december",
  ];
  const formatDate = () => {
    // date arrives as dd-mm-yyyy (chart date = today's day/month in the shown year)
    if (date && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
      const [d, m, y] = date.split("-");
      return `${parseInt(d, 10)} ${NL_MONTHS[parseInt(m, 10) - 1]} ${y}`;
    }
    const now = new Date();
    return `${now.getDate()} ${NL_MONTHS[now.getMonth()]} ${year || "\u2026"}`;
  };

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const res = await fetch(`${API}/top40?limit=3`);
        if (!res.ok) return;
        const data = await res.json();
        if (active && data && Array.isArray(data.items)) {
          setItems(data.items);
          setYear(data.year);
          setDate(data.date || "");
        }
      } catch (e) {
        /* ignore */
      }
    };
    load();
    const id = setInterval(load, 60 * 60 * 1000); // hourly
    return () => { active = false; clearInterval(id); };
  }, []);

  if (!items.length) return null;

  return (
    <section className="pt-0 pb-24">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#4288F5] border border-white/15 p-6 sm:p-8 shadow-[0_18px_40px_-22px_rgba(8,30,80,0.5)]">
          <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/10 blur-3xl" />
          <div className="relative">
            <h3 className="font-heading text-lg sm:text-xl font-extrabold leading-snug text-white">
              Dit was de Top 3 in de &ldquo;Nederlandse Top 40&rdquo; van {formatDate()}!
            </h3>
          </div>

          <div className="relative mt-5 space-y-2">
            {items.map((t) => (
              <div key={t.position} className="flex items-center gap-4 rounded-2xl bg-white/10 px-4 py-3 transition-colors hover:bg-white/15">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white font-heading text-lg font-extrabold text-[#1E6BE6] shadow">
                  {t.position}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="font-heading font-bold leading-snug text-white">{t.title}</p>
                  <p className="text-sm text-white/75">{t.artist}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Top40Chart;
